import {
  DELETE_USER,
  DELETE_USER_FAIL,
  DELETE_USER_SUCCESS,
  GENERATE_PASSWORD,
  GENERATE_PASSWORD_SUCCESS,
  GENERATE_PASSWORD_FAIL
} from "./actionType"

//Delete user
export const deleteUser = (history, id) => {
  return {
    type: DELETE_USER,
    payload: { history, id },
  }
}
export const deleteUserSuccess = user => {
  return {
    type: DELETE_USER_SUCCESS,
    payload: user,
  }
}
export const deleteUserError = error => {
  return {
    type: DELETE_USER_FAIL,
    payload: error,
  }
}

//Generate password
export const GeneratePassword = (history, id, path) => {
  return {
    type: GENERATE_PASSWORD,
    payload: { history, id, path },
  }
}
export const GeneratePasswordSuccess = pwd => {
  return {
    type: GENERATE_PASSWORD_SUCCESS,
    payload: pwd,
  }
}
export const GeneratePasswordFail = error => {
  return {
    type: GENERATE_PASSWORD_FAIL,
    payload: error,
  }
}
